import { render, staticRenderFns } from "./ResourceCenter.vue?vue&type=template&id=a469c686&scoped=true&"
import script from "./ResourceCenter.vue?vue&type=script&lang=js&"
export * from "./ResourceCenter.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCenter.vue?vue&type=style&index=0&id=a469c686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a469c686",
  null
  
)

export default component.exports